import { useScopedTranslation } from '../../application/localization/useScopedTranslation.ts';
import styles from './ContactsPage.module.scss';
import { Breadcrumbs } from '../../components/uikit/Breadcrumbs.tsx';
import MailIcon from '../../assets/icons/mail.svg?react';
import { Button, ButtonColor } from '../../components/uikit/buttons/Button.tsx';
import UserReportModal from '../authorized/rootPage/components/UserReportModal.tsx';
import { useState } from 'react';

import { Tooltip } from '../../components/uikit/Tooltip.tsx';
import pageStyles from '../authorized/warranty-request/WarrantyRequest.module.scss';
import { useAnalytics } from 'helpers/analytics.ts';

export const ContactsCategory = 'Contacts';

const Mail = 'CustomerService@loewensteinmedical.com';
const SupportDeskMail = 'supportHC@loewensteinmedical.com';

const ContactsPage = () => {
  const i18n = useScopedTranslation('Page.ContactsPage');
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isUserReportModalShown, setIsUserReportModalShown] = useState(false);
  const { trackEvent } = useAnalytics();

  return (
    <>
      <Breadcrumbs />
      <div className={styles.contactsContainer}>
        <div className={styles.title}>{i18n.t('main_text')}</div>
        <div className={styles.contacts}>
          <div>
            <div className={styles.iconContainer}>
              <MailIcon />
            </div>
            <p>{i18n.t('mail')}</p>
            <a href={'mailto:' + Mail}>{Mail}</a>
          </div>
          <div>
            <div className={styles.iconContainer}>
              <MailIcon />
            </div>
            <p>{i18n.t('support_desk_mail')}</p>
            <a href={'mailto:' + SupportDeskMail}>{SupportDeskMail}</a>
          </div>
        </div>
        <div className={styles.reportContainer}>
          <div className={styles.title}>{i18n.t('report_text')}</div>
          <Button
            onClick={() => {
              trackEvent({
                category: ContactsCategory,
                action: 'Click report issue',
                name: 'Click report issue',
              });
              setIsUserReportModalShown(true);
            }}
            className={styles.reportButton}
            color={ButtonColor.Secondary}
            title={i18n.t('report_button')}
          />
        </div>
      </div>
      {isUserReportModalShown && (
        <UserReportModal
          onClose={() => {
            setIsUserReportModalShown(false);
          }}
          onSubmit={() => {
            setIsUserReportModalShown(false);
            setIsTooltipVisible(true);
            setTimeout(() => {
              setIsTooltipVisible(false);
            }, 2500);
          }}
        />
      )}
      {isTooltipVisible && (
        <Tooltip
          closeTooltip={() => setIsTooltipVisible(false)}
          bodyContent={<div>{i18n.t('tooltip_message')}</div>}
          className={pageStyles.tooltip}
          showCancelButton={true}
        />
      )}
    </>
  );
};

export default ContactsPage;
